import { Outlet } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Header from "./Header";
import Sidebar from "./Sidebar";
import MlobbyIframeNew from "../component/casino/MlobbyIframeNew";
import { getBalanceCRefAsync } from "../store/slices/betSlice";
import { setAuthFromStorage } from "../store/slices/authSlice";
import { getAuthToken, getUserData } from "../utils/auth";
import { getBalanceInterval } from "../env";
import { fetchHomeAllMatches } from "../store/slices/matchesSlice";
import {
  fetchSocialMediaContent,
  getSeriesInfoBySportsName,
  getSlides,
  getSportsInfoAsync,
  clearSocialMediaContent,
} from "../store/slices/sidebarSlice";
import { fetchNewsAsync } from "../store/slices/newsSlice";
import { getBonusesAmountsAsync } from "../store/slices/bonusSlice";
import { fetchWalletSummary } from "../store/slices/walletSlice";

const startOfLocalDayISO = (d = new Date()) => {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x.toISOString();
};

const endOfLocalDayISO = (d = new Date()) => {
  const x = new Date(d);
  x.setHours(23, 59, 59, 999);
  return x.toISOString();
};

const getWalletSummaryRange = (range = "LAST_7_DAYS") => {
  const today = new Date();

  if (range === "TODAY") {
    return {
      from_date: startOfLocalDayISO(today),
      to_date: endOfLocalDayISO(today),
    };
  }

  // Default: last 7 days (including today)
  const from = new Date(today);
  from.setDate(from.getDate() - 7);
  return {
    from_date: startOfLocalDayISO(from),
    to_date: endOfLocalDayISO(today),
  };
};

const MainLayout = () => {
  const dispatch = useDispatch();
  const { user, token } = useSelector((state) => state.auth);
  const isLoggedIn = !!(user || token);

  // Hydrate auth state from localStorage on first load/refresh
  useEffect(() => {
    if (typeof window === "undefined") return;
    const storedToken = getAuthToken();
    const storedUser = getUserData();
    if (storedToken || storedUser) {
      dispatch(setAuthFromStorage({ token: storedToken, user: storedUser }));
    }
  }, [dispatch]);

  useEffect(() => {
    if (!isLoggedIn) return;

    // Initial fetch
    dispatch(getBalanceCRefAsync());
    dispatch(
      fetchWalletSummary({
        ...getWalletSummaryRange("LAST_7_DAYS"),
        limit: 100,
      }),
    );
    // Poll balance every 4 seconds while logged in
    const intervalId = setInterval(() => {
      dispatch(getBalanceCRefAsync());
    }, getBalanceInterval);

    return () => clearInterval(intervalId);
  }, [dispatch, isLoggedIn]);

  const sportsIds = [1,2,4]
  const racingSportsIds = [7,4339]
  const fetchingSeries = async()=>{
    
    await new Promise(resolve => setTimeout(resolve, 3000));
    await Promise.all(sportsIds.map(async (sportId) => {
      await dispatch(getSeriesInfoBySportsName({ sportId }));
    }));
    await Promise.all(racingSportsIds.map(async (sportId) => {
      await dispatch(getSeriesInfoBySportsName({ sportId, isRacingMarket: true }));
    }));
  }


  useEffect(() => {
    dispatch(fetchHomeAllMatches());
    dispatch(getSlides());
    if(!isLoggedIn) return;

    dispatch(getBonusesAmountsAsync());
    dispatch(fetchNewsAsync()).catch(() => {});
    dispatch(getSportsInfoAsync());
    dispatch(fetchSocialMediaContent(true));

    // this is because the series info is not available immediately after the sports info is fetched
    setTimeout(() => {
      // fetchingSeries();
    }, 1000);
  }, [dispatch, isLoggedIn]);

  useEffect(() => {
    if (isLoggedIn) return;
    dispatch(clearSocialMediaContent());
  }, [dispatch, isLoggedIn]);

  
  return (
    <>
      <Header />
      <Sidebar />
      <main id="main" className="main">
        <div className="router-ctn">
          <Outlet />
        </div>
      </main>
      <MlobbyIframeNew />
    </>
  );
};

export default MainLayout;
